import { FrontPage, LoginPageScreen, SingleSearchResult } from 'Pages'
import { useEffect } from 'react'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'

import './App.scss'
import i18next from 'i18next'
import AuthHeaderBlock from '../Components/SubscribeService/AuthHeader'
import TopBlockSmall from '../Components/SubscribeService/TopBlockSmall'
import {
  fetchCurrentUser,
  fetchHeaderNavigationElements,
  fetchInitialSettings
} from '../Features/Auth/authSlice'
import LogoutPage from '../Pages/LoginPage/LogoutPage'
import FirstStep from '../Pages/Payment/FirstStep'
import SecondStep from '../Pages/Payment/SecondStep'
import Success from '../Pages/Payment/Success'
import EmailChangeScreen from '../Pages/PersonalInfo/EmailChange'
import EmailVerification from '../Pages/PersonalInfo/EmailVerification'
import PasswordChangeScreen from '../Pages/PersonalInfo/PasswordChange'
import PersonalInfoScreen from '../Pages/PersonalInfo/PersonalInfo'
import { useAppDispatch } from '../Store'
import PrivateRoute from '../Util/PrivateRoute'
import TokenUtil from '../Util/tokenManager'
import MuiXLicense from './MUILicence'

const App = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const key = TokenUtil.get()
    if (key) {
      dispatch(fetchCurrentUser())
    }

    // Initial data fetch (settings & header data)
    dispatch(fetchInitialSettings())

    const params = new URLSearchParams(window.location.search)
    let lang = params.get('lang') || 'fi'

    if (!Object.keys(i18next.services.resourceStore.data).includes(lang)) {
      lang = 'fi'
    }

    dispatch(fetchHeaderNavigationElements(lang))
    i18next.changeLanguage(lang)
  })

  return (
    <Router>
      <div className="App">
        <MuiXLicense />
        <AuthHeaderBlock />
        <TopBlockSmall />
        <Switch>
          <Route component={EmailVerification} path="/verify-email/:key/" />
          <Route component={PersonalInfoScreen} path="/personal-info" />
          <Route component={PasswordChangeScreen} path="/password-change" />
          <Route component={EmailChangeScreen} path="/email-change" />
          <Route component={LoginPageScreen} path="/migration-login" />
          <Route component={LogoutPage} path="/migration-logout" />
          <Route component={SingleSearchResult} path="/:registry/:id" />
          <PrivateRoute component={FirstStep} path="/expired" />
          <PrivateRoute component={SecondStep} path="/payment" />
          <PrivateRoute component={Success} path="/success" />
          <Route component={FrontPage} path="/" />
        </Switch>
      </div>
    </Router>
  )
}

export default App